export enum EthnicKey {
  // mexican = 'mexican',
  chinese = 'chinese',
  japanese = 'japanese',
  korean = 'korean',
  vietnamese = 'vietnamese',
  filipino = 'filipino',
  indian = 'indian',
  asian = 'asian'
}

export enum EthnicKeySEO {
  chinese = 'chinese',
  japanese = 'japanese',
  korean = 'korean',
  vietnamese = 'vietnamese',
  filipino = 'filipino',
  indian = 'indian',
  thai = 'thai'
}

export enum EthnicKeyMasgustoSEO {
  mexican = 'mexican',
  brazilian = 'brazilian',
  dominican = 'dominican',
  puertorican = 'puertorican'
}

export interface EthnicServeProps {
  data: any;
  seoInfo?: {
    keywords?: string;
    description?: string;
    title?: string;
    h1?: string;
  };
  relatedTopicsData?: any;
}

export enum EthnicLandingType {
  ethnic = 'ethnic',
  geo_ethnic = 'geo_ethnic'
}
